import { RteContentType } from '@/types';

export const orderRteContentByUpdatedDesc = (
  a: RteContentType,
  b: RteContentType,
) => {
  if (!a.lastUpdatedMs || !b.lastUpdatedMs) {
    return 0;
  }
  if (a.lastUpdatedMs > b.lastUpdatedMs) {
    return -1;
  }
  if (a.lastUpdatedMs < b.lastUpdatedMs) {
    return 1;
  }
  return 0;
};
